import { useState } from 'react';

import { ResponsiveContainer } from '../ResponsiveContainer';

import {
    Dropdown,
    Container,
    Message,
    Input,
    Segment,
    Header,
    Divider,
    Button,
} from 'semantic-ui-react'

import { useMutation, useQuery, gql } from '@apollo/client';


const ADD_TAG = gql`
mutation CreateTag($groupId: Int!, $name: String!, $code: String!) {
    createTag(groupId: $groupId, name: $name, code: $code) {
        status
    }
}`;

const GET_TAG_GROUPS = gql`
query TagGroups {
    tagGroups {
        id
        name
    }
}`;


const Tags = () => {
    const [name, setName] = useState('')
    const [code, setCode] = useState('')
    const [isCodeInUse, setIsCodeInUse] = useState(false)
    const [groupId, setGroupId] = useState<number | null>(null)

    // mutation to add tags
    const [createTag] = useMutation(ADD_TAG);

    // get all the tag groups
    const { loading, error, data } = useQuery(GET_TAG_GROUPS);

    const handleCreateTag = async () => {
        // call mutation and get the status back
        const mutationData = await createTag({
            variables: {
                groupId: groupId!,
                name: name,
                code: code
            }
        });

        if (mutationData.data.createTag.status !== 'OK') {
            // show the message and return
            setIsCodeInUse(true);
            return
        } else {
            setIsCodeInUse(false);
        }

        setName('');
        setCode('');
    }

    return (
        <ResponsiveContainer>
        <Segment style={{ padding: '0em 0em' }} vertical>
            <Container>
            <Divider horizontal>
                <Header as='h2'>
                Tags
                </Header>
            </Divider>
                <Input
                    placeholder='Tag name'
                    value={name}
                    fluid
                    onChange={(e) => setName(e.target.value)}
                />
                <br/>
                {isCodeInUse &&
                    <Message
                        warning
                        header='Sorry, that tag code is already in use.'
                        content='Please pick another'
                    />
                }
                <Input
                    placeholder='Tag code'
                    value={code}
                    fluid
                    onChange={(e) => setCode(e.target.value.toUpperCase())}
                />
                <br/>
                {!loading && !error && <Dropdown
                    placeholder='Tag group'
                    fluid
                    lazyLoad
                    selection
                    value={groupId || undefined}
                    onChange={(_, { value }) => setGroupId(value as number)}
                    options={data.tagGroups.map((tagGroup:any) => {
                        return {
                            key: tagGroup.id,
                            text: tagGroup.name,
                            value: tagGroup.id
                        }
                    })}
                />}
                <br/>
                <Button
                    primary
                    disabled={name.length === 0 || code.length === 0 || groupId === null}
                    onClick={() => handleCreateTag()}>Create tag</Button>
                                           <br/>
                                           <br/>
                                           <br/>
                                           <br/>
            </Container>
        </Segment>

        </ResponsiveContainer>
    )
}

export { Tags }
